<template>
  <div>
    <breadcrumb :routerList="[{to:'/contract-list',title:'合同列表'},{to: $route.fullPath, title:'合同修改'}]"/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formLine weekplandetail" style="padding-bottom: 100px;">
          <el-form :model="formInline" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
            <el-form-item label="合同名称" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.contractName"></el-input>
            </el-form-item>
            <el-form-item label="合同类型" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.contractCatecoryName"></el-input>
            </el-form-item>
            <el-form-item label="关联项目" class="h-elformWrap-2" v-if="!zlflag">
              <el-input readonly v-model="formInline.pid"></el-input>
            </el-form-item>
            <el-form-item :label="customerlabel" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.customerName"></el-input>
            </el-form-item>
            <el-form-item label="物流方式" class="h-elformWrap-2" >
              <el-input readonly v-if="formInline.wuliufangshi==1" value="海尔自有物流"></el-input>
              <el-input readonly v-if="formInline.wuliufangshi==2" value="供应商直发"></el-input>
              <el-input readonly v-if="formInline.wuliufangshi==3" value="海尔自有物流和供应商直发皆可"></el-input>
            </el-form-item>
            <el-form-item label="付款日期" class="h-elformWrap-2" prop="payDate">
              <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formUpdate.payDate"></el-date-picker>
            </el-form-item>
            <el-form-item label="云超市合同号" class="h-elformWrap-2" v-if="cgflag">
              <el-input v-model="formInline.contractCode"></el-input>
            </el-form-item>
            <el-col>
              <el-form-item label="原合同开始时间" class="h-elformWrap-2">
                <el-input readonly v-model="formInline.contractStarttime"></el-input>
              </el-form-item>
              <el-form-item label="新合同开始时间" class="h-elformWrap-2">
                <el-date-picker
                    :clearable="false"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择时间"
                    v-model="formUpdate.contractStarttime">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="原合同结束时间" class="h-elformWrap-2">
                <el-input readonly v-model="formInline.contractEndtime"></el-input>
              </el-form-item>
              <el-form-item label="新合同结束时间" class="h-elformWrap-2">
                <el-date-picker
                    :clearable="false"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择时间"
                    v-model="formUpdate.contractEndtime">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
        <div >
          <div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
            <h1>产品信息</h1>
          </div>
          <el-form ref="form4" :model="formInline">
            <el-table
                ref="multipleTable"
                :data="formInline.productList"
                style="width: 100%"
            >
              <el-table-column
                  type="index"
                  label="#" width="40">
              </el-table-column>
              <el-table-column
                  prop="productId"
                  label="产品型号" width="180">
              </el-table-column>
              <el-table-column
                  prop="productName"
                  label="产品名称" width="180">
              </el-table-column>
              <el-table-column
                   prop="oemDesc"
                   label="规格型号" width="180">
              </el-table-column>
              <el-table-column
                  prop="unitPrice"
                  label="产品价格" width="120">
              </el-table-column>
              <el-table-column
                  prop="shuilv"
                  label="发票税率" width="120">
                <template scope="scope">
                  <brselect category="cgshuilv" :v="scope.row.shuilv" disabled v-model="scope.row.shuilv"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="cgjingli"
                  label="采购经理">
                <template scope="scope">
                  <brselect :multiple="true" category="cg_manage" v-model="scope.row.cgjingli" :v="scope.row.cgjingli"
                            />
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div v-if="false">
          <div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
            <h1>租赁型号</h1>
          </div>
          <el-table
              ref="multipleTable"
              :data="formInline.zlList"
              style="width: 100%"
          >
            <el-table-column
                type="index"
                width="40"
                label="#">
            </el-table-column>
            <el-table-column
                prop="productType"
                :show-overflow-tooltip="true"
                label="产品大类">
            </el-table-column>
            <el-table-column
                prop="productCode"
                :show-overflow-tooltip="true"
                label="产品型号">
            </el-table-column>
            <el-table-column
                prop="productName"
                :show-overflow-tooltip="true"
                label="产品名称">
            </el-table-column>
            <el-table-column
                prop="rentNum"
                width="100"
                label="租赁数量">
            </el-table-column>
          </el-table>
        </div>
        <div v-if="false">
          <div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
            <h1>付款节点</h1>
          </div>
          <el-form ref="form3">
            <el-table
                ref="multipleTable"
                :data="formInline.paymentList"
                style="width: 100%"
            >
              <el-table-column
                  type="index"
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="nodeName"
                  label="节点名称"
                  :show-overflow-tooltip="true">
                <template scope="scope">
                  {{ scope.row.nodeName }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentRatio"
                  label="付款比例(%)" width="200">
                <template scope="scope">
                  {{ scope.row.paymentRatio }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentAmount"
                  v-if="zlflag"
                  label="开票金额" width="200">
                <template scope="scope">
                  {{ scope.row.paymentAmount }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="netValue"
                  v-if="zlflag"
                  label="净价值" width="200">
                <template scope="scope">
                  {{ scope.row.netValue }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentDays"
                  label="账期(天)"
                  width="200">
                <template scope="scope">
                  {{ scope.row.paymentDays }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="isNeedcred"
                  label="是否需要凭证"
                  width="200">
                <template scope="scope">
                  <span v-if="scope.row.isNeedcred==1">是</span>
                  <span v-if="scope.row.isNeedcred==0">否</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div v-if="false" style="margin-top: 0.3rem;">
          <el-form ref="form3" :model="formInline">
            <el-table
                ref="multipleTable"
                :data="formInline.fukuanobj"
                style="width: 100%"
            >
              <el-table-column
                  type="index"
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="nodeName"
                  label="节点名称">
                <template scope="scope">
                  {{ scope.row.nodeName }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentRatio"
                  label="付款比例(%)" width="200">
                <template scope="scope">
                  {{ scope.row.paymentRatio }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentAmount"
                  label="付款金额(元)" width="200">
                <template scope="scope">
                  {{ scope.row.paymentAmount }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="netValue"
                  label="净价值(元)" width="200">
                <template scope="scope">
                  {{ scope.row.netValue }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentDays"
                  label="账期(天)"
                  width="150">
                <template scope="scope">
                  {{ scope.row.paymentDays }}
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div v-if="false" class="h-formLine h-mrt40 weekplandetail1">
          <el-form :model="formInline" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
            <el-form-item label="合同附件" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2">
              <brupload :refid="this.contractId" reftype="合同附件"></brupload>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="h-txtCenter h-mrt60">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import util from "../../../utils/util";
import big from "big.js";
import { cloneDeep } from 'loadsh'
export default {
  name: 'leftMenu',
  data() {
    return {
      customerlabel: "客户名称",
      cgflag: false,
      zlflag: false,
      bzflag: false,
      //表单
      formInline: {},
      //表单
      formUpdate: {
      },
      contractId: this.$route.query.key,
      //多选
      checkList: [],
      fileList: [],
      zlxh: [
        {
          productType: 'NA4',
          productCode: 'BF0260B04',
          productName: 'DW-25W198',
          rentNum: '8'
        }
      ],
      fukuanobj: [
        {
          nodeName: "",
          newflag: false,
          paymentRatio: "",
          paymentAmount: "",
          netValue: "",
          paymentDays: "",
          billPayMonty: ""
        }
      ],
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.formUpdate.contractEndtime) {
            return time.getTime() > new Date(this.formUpdate.contractEndtime.replace(/-/gi,'/')).getTime();
          }
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.formUpdate.contractStarttime) {
            return time.getTime() < new Date(this.formUpdate.contractStarttime.replace(/-/gi,'/')).getTime();
          }
        }
      },
    }
  },
  methods: {
    cancel() {
      this.$router.push("contract-list");
    },
    submit() {

      let form = {
        ...this.formUpdate,
        oldContractStarttime: this.formInline.contractStarttime,
        oldContractEndtime: this.formInline.contractEndtime,
        contractId: this.formInline.id,
        contractName: this.formInline.contractName,
        contractCode: this.formInline.contractCode,
        productList: cloneDeep(this.formInline.productList).map(item => {
            item['oldId'] = item.id;
            delete item['id'];
            return item
        })
      }
      // TODO 验证
      ss.contractService.bscContractEdit(form).then(rd => {
        if (rd.f) {
          this.$msg.msgs("提交成功！");
          this.$router.push("contract-list");
        } else {
          this.$msg.msge("提交失败！" + rd.msg);
        }
      })
    },
    formatDate(date){
      if (this.isNotEmpty(date)) {
        function addDateZero(num) {
          return (num < 10 ? "0" + num : num);
        }
        let d = new Date(date);
        let format = d.getFullYear()+"-"+addDateZero(d.getMonth()+1)+"-"+addDateZero(d.getDate());
        return format;
      }
    },
  },
  mounted() {
    ss.contractService.detail(this.contractId).then(rd => {
      this.formInline = rd.obj;
      this.formInline.productList = this.formInline.productList.map( item => {
        item['oldCgjingli'] = item.cgjingli;
        return item
      })
      if (this.formInline.contractCatecory == "CT-CG") {
        this.cgflag = true;
      }
      // 赋值
      this.formUpdate = { contractStarttime: this.formInline.contractStarttime, contractEndtime: this.formInline.contractEndtime,payDate:this.formInline.payDate}
    });
  }
}
</script>

<style scoped>
.texts {
  color: #2a89d6;
  font-size: 18px;
  text-decoration: underline
}
</style>
<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '年';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}

.weekplandetail .h-formbLine .el-form-item__label {
  width: 36%;
  text-align: right;
}

.weekplandetail .h-formbLine .el-form-item__content {
  width: 64%;
}

.weekplandetail .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem
}

.weekplandetail .h-formbLine .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 10.4%;
}

.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 89.6%;
}

.weekplandetail2 .h-formbLine .h-elformWrap-2 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 22.4%;
  vertical-align: middle;
}

.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__content {
  width: 77.6%;
}

.weekplandetail1 .h-formbLine .h-elformWrap-2 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 7%;
  vertical-align: middle;
}

.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__content {
  width: 93%;
}
</style>
